import React, { useEffect, useState } from "react";
import { SignDialog } from "../components/dialog/SignDialog";
import { SignsTable } from "../components/search/SignsTable";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { PageTitle } from '../components/utils/PageTitle';
import { useDataProvider } from "../api/DataProvider";


export function FavoriteSigns() {
  /* Dialog */
  const [dialogElements, setDialogElements] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const { currentUserRole, genEntryByLemma } = useDataProvider();
  const [prevDialogPosition, setPrevDialogPosition] = useState(undefined);
  // const [feedback, setFeedback] = useState([]);

  /* Show dialog */
  async function showDialog(row_id) {
    setDialogElements(genEntryByLemma(row_id));
    setOpenDialog(true);
  }

  return (
    <HomeWrapper>
      <PageTitle title="FAVORITOS" />
      <SignsTable showDialog={showDialog} favs={true} />
      <SignDialog dialogElements={dialogElements} setDialogElements={setDialogElements} loading={false} openDialog={openDialog} setOpenDialog={setOpenDialog} setPrevDialogPosition={setPrevDialogPosition}/>
    </HomeWrapper>
  );
}
